/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { forwardRef } from "react"
import { InputAdornmentProps as MUIInputAdornmentProps } from "@mui/material"
import { Box, createPolymorphicComponent } from "@mantine/core"
import cx from "classnames"

import styles from "./InputAdornment.mantine.module.scss"

export const InputAdornment = createPolymorphicComponent<
  "div",
  MUIInputAdornmentProps
>(
  // eslint-disable-next-line react/display-name
  forwardRef<HTMLDivElement, MUIInputAdornmentProps>((props, ref) => {
    const classNames = cx(styles.root, styles[`adornment-${props.position}`])
    return (
      <Box
        component={props.component as any}
        {...props}
        className={classNames}
        ref={ref as any}
      />
    )
  }),
)

InputAdornment.displayName = "InputAdornment"

export default InputAdornment
